import { map } from 'lodash';
import {
  SvgIconComponent,
  Deblur,
  Block,
  BarChart,
  Notifications,
  Book,
  Adjust,
  CheckBox,
  QuestionAnswer,
  Speed,
  AttachMoney,
  Edit,
  Email,
  MailOutline,
  LocalFireDepartment,
  Folder,
  FolderOpen,
  Settings,
  Engineering,
  Feed,
  History,
  Home,
  Lightbulb,
  List,
  AutoFixHigh,
  LocalAtm,
  PauseCircle,
  AddBox,
  Extension,
  Shuffle,
  HighlightOff,
  Send,
  Share,
  Logout,
  PersonPinCircle,
  TableView,
  ViewList,
  ThumbUp,
  InvertColors,
  Person,
  Group,
} from '@mui/icons-material';
import { IOption } from '@shared/interfaces';
import { EMenuIcon, IMenuItemIconOption, EMenuItemType } from './types';

export const MENU_COLOR_BLUE = '#3c8dbc';
export const MENU_COLOR_DARK_BLUE = '#2a6384';
export const MENU_COLOR_RED = '#d44646';
export const MENU_COLOR_DARK_RED = '#a20000';

export const MENU_ITEM_ICONS: Record<EMenuIcon, SvgIconComponent> = {
  [EMenuIcon.Adjust]: Deblur,
  [EMenuIcon.Ban]: Block,
  [EMenuIcon.BarChart]: BarChart,
  [EMenuIcon.Bell]: Notifications,
  [EMenuIcon.Book]: Book,
  [EMenuIcon.Bullseye]: Adjust,
  [EMenuIcon.CheckSquareOutlined]: CheckBox,
  [EMenuIcon.Comments]: QuestionAnswer,
  [EMenuIcon.Dashboard]: Speed,
  [EMenuIcon.Dollar]: AttachMoney,
  [EMenuIcon.Edit]: Edit,
  [EMenuIcon.Envelope]: Email,
  [EMenuIcon.EnvelopeOutlined]: MailOutline,
  [EMenuIcon.Fire]: LocalFireDepartment,
  [EMenuIcon.Folder]: Folder,
  [EMenuIcon.FolderOpenOutlined]: FolderOpen,
  [EMenuIcon.Gear]: Settings,
  [EMenuIcon.Gears]: Engineering,
  [EMenuIcon.HackerNews]: Feed,
  [EMenuIcon.History]: History,
  [EMenuIcon.Home]: Home,
  [EMenuIcon.LightbulbOutlined]: Lightbulb,
  [EMenuIcon.List]: List,
  [EMenuIcon.Magic]: AutoFixHigh,
  [EMenuIcon.Money]: LocalAtm,
  [EMenuIcon.PauseCircleOutlined]: PauseCircle,
  [EMenuIcon.PlusSquare]: AddBox,
  [EMenuIcon.PuzzlePiece]: Extension,
  [EMenuIcon.Random]: Shuffle,
  [EMenuIcon.Remove]: HighlightOff,
  [EMenuIcon.Send]: Send,
  [EMenuIcon.ShareAltSquare]: Share,
  [EMenuIcon.SignOut]: Logout,
  [EMenuIcon.StreetView]: PersonPinCircle,
  [EMenuIcon.Table]: TableView,
  [EMenuIcon.ThList]: ViewList,
  [EMenuIcon.ThumbsUp]: ThumbUp,
  [EMenuIcon.Tint]: InvertColors,
  [EMenuIcon.User]: Person,
  [EMenuIcon.Users]: Group,
};

export const MENU_ICONS_ORDER: EMenuIcon[] = [
  EMenuIcon.Adjust,
  EMenuIcon.Ban,
  EMenuIcon.BarChart,
  EMenuIcon.Bell,
  EMenuIcon.Book,
  EMenuIcon.Bullseye,
  EMenuIcon.CheckSquareOutlined,
  EMenuIcon.Comments,
  EMenuIcon.Dashboard,
  EMenuIcon.Dollar,
  EMenuIcon.Edit,
  EMenuIcon.Envelope,
  EMenuIcon.EnvelopeOutlined,
  EMenuIcon.Fire,
  EMenuIcon.Folder,
  EMenuIcon.FolderOpenOutlined,
  EMenuIcon.Gear,
  EMenuIcon.Gears,
  EMenuIcon.HackerNews,
  EMenuIcon.History,
  EMenuIcon.Home,
  EMenuIcon.LightbulbOutlined,
  EMenuIcon.List,
  EMenuIcon.Magic,
  EMenuIcon.Money,
  EMenuIcon.PauseCircleOutlined,
  EMenuIcon.PlusSquare,
  EMenuIcon.PuzzlePiece,
  EMenuIcon.Random,
  EMenuIcon.Remove,
  EMenuIcon.Send,
  EMenuIcon.ShareAltSquare,
  EMenuIcon.SignOut,
  EMenuIcon.StreetView,
  EMenuIcon.Table,
  EMenuIcon.ThList,
  EMenuIcon.ThumbsUp,
  EMenuIcon.Tint,
  EMenuIcon.User,
  EMenuIcon.Users,
];

export const menuItemIconOptions: IMenuItemIconOption[] = map<EMenuIcon, IMenuItemIconOption>(
  MENU_ICONS_ORDER,
  (icon) => ({
    value: icon,
    label: icon,
  }),
);

export const MENU_ITEM_TYPE_OPTIONS: IOption[] = [
  { value: EMenuItemType.Queue, label: 'Queue' },
  { value: EMenuItemType.Link, label: 'Link' },
  { value: EMenuItemType.Header, label: 'Header' },
  { value: EMenuItemType.Divider, label: 'Divider' },
];
